import { EventDataParametersType, EventRequestDataType } from '../../types'

import { sendEvent } from '../../api'

import { getEventData } from './helpers/getEventData'

export const getSender = () => ({
  createEventData: (eventParameters: EventDataParametersType) => getEventData(eventParameters),
  sendEvent: async (data: EventRequestDataType) => {
    const { brandId, apiDomain, ...requestData } = data

    try {
      await sendEvent(requestData, brandId, apiDomain)
    } catch (error) {
      console.error(error)
    }
  },
})
